import { useTranslation } from '@supply-mover-2-0/web-ui';
import type { JSX } from 'react';
import { NETWORK_BLOCKED_MESSAGE } from '../lib/portalNetworkError';

/**
 * PD-17406 — shown instead of the storefront when its start-up request could
 * not reach our servers at all (see PortalNetworkError). It used to fall
 * through to "Page not found", which sent the shopper looking for a wrong
 * address when the real problem was their network blocking the connection.
 * Laid out like NotFoundPage, since neither has a brand to show yet.
 */
export function ConnectionBlockedPage(): JSX.Element {
	const { t } = useTranslation();

	return (
		<div className="min-h-dvh flex items-center justify-center bg-brand-page-bg px-4">
			<div className="text-center max-w-md">
				<p className="text-lg text-brand-muted mb-2">
					{t("We couldn't connect")}
				</p>
				<p className="text-sm text-brand-muted">{t(NETWORK_BLOCKED_MESSAGE)}</p>
			</div>
		</div>
	);
}
